import withReadOnly from '../ReadOnlyAbilityWrapper';
import CheckboxDropdown from './CheckboxDropdown';
import { wrapInLabel } from '../NewInputLabelWrapper';

export default withReadOnly(wrapInLabel(CheckboxDropdown));
